import React from "react";
import { connect } from "react-redux";
import FilterModal from "../modals/FilterModal";

// return filters, filtertags, and sites
class DistrictFilterModal extends React.Component {
  constructor(props) {
    super(props);
  }

  getCategories = () => {
    return this.props.categories.filter((d) => d.for_doors);
  };

  render() {
    return (
      <div data-component="DistrictFilterModal">
        <FilterModal
          title="Filter Districts"
          {...this.props}
          categories={this.getCategories()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  categories: state.siteNotes.categories,
});

export default connect(mapStateToProps)(DistrictFilterModal);
